<template>
  <el-dialog
    :title="title"
    append-to-body
    destroy-on-close
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="600px"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="战略合伙人名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入" clearable/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loadingSubmit" :disbaled="loadingSubmit" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { addEnterprise as add, updateEnterprise as edit } from 'api/request'
  export default {
    data () {
      return {
        title: '新增战略合伙人',
        visible: false,
        loadingSubmit: false,
        // 表单参数
        form: {
          id: undefined,
          name: '',
        },
        // 表单校验
        rules: {
          name: [
            {required: true, message: '请输入战略合伙人名称', trigger: 'blur'}
          ],
        }
      }
    },
    watch: {
      visible (val) {
        if (!val) {
          Object.assign(this.$data, this.$options.data.call(this));
        }
      },
    },
    methods: {
      show(data) {
        if (data.id) {
          this.title = '编辑战略合伙人'
          this.form = data
        }
        this.visible = true
      },
      submitForm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let data = { ...this.form }
            let api = data.id ? edit : add
            api(data).then(res => {
              this.loadingSubmit = false;
              if (res) {
                this.$emit('done', data.id);
                this.$message.success('操作成功');
                this.visible = false;
              }
            })
          }
        });
      },
      /*取消*/
      cancel () {
        Object.assign(this.$data, this.$options.data.call(this));
      },
    }
  }
</script>

<style scoped lang="scss">

</style>
